<template>
  <div>
    <ul class="filter_list w100">
      <li>
        <dd>
          <label class="w30">수신 사업장<span class="forg">*</span></label>
          <ul class="w70">
            <li>
              <kendo-dropdownlist
                  class="w100"
                  ref="receiveFacilityRef"
                  :data-text-field="'cdNm'"
                  :data-value-field="'cdId'"
                  v-model="pouchInfo.receiveFacility"
                  :option-label="'수신 사업장 선택'"
                  :data-source="zone1DepthListForPouch"
                  @change="onChangeFacility('receive')"
                  :filter="'contains'"
              >
              </kendo-dropdownlist>
            </li>
          </ul>
        </dd>
        <dd>
          <label class="w30">수신<span class="forg">*</span></label>
          <ul class="w70">
            <li>
              <kendo-maskedtextbox
                  class="w100"
                  :placeholder="'수신처를 입력하세요.'"
                  v-model.trim="pouchInfo.receiveNm"
              >
              </kendo-maskedtextbox>
            </li>
          </ul>
        </dd>
      </li>
      <li>
        <dd>
          <label class="w30">수신 거점</label>
          <ul class="w70">
            <li>
              <kendo-dropdownlist
                  class="w100"
                  ref="receiveAreaRef"
                  :data-text-field="'cdNm'"
                  :data-value-field="'cdId'"
                  v-model="pouchInfo.receiveArea"
                  :option-label="'수신 거점 선택'"
                  @change="onChangeArea('receive')"
              >
              </kendo-dropdownlist>
            </li>
          </ul>
        </dd>
        <dd>
          <label class="w30">수신 부서<span class="forg">*</span></label>
          <ul class="w70">
            <li>
              <kendo-maskedtextbox
                  class="w100"
                  :placeholder="'수신 부서를 입력하세요.'"
                  v-model.trim="pouchInfo.receiveDept"
              >
              </kendo-maskedtextbox>
            </li>
          </ul>
        </dd>
      </li>
      <li>
        <dd>
          <label class="w30">수신 코스</label>
          <ul class="w70">
            <li>
              <kendo-dropdownlist
                  class="w100"
                  ref="receiveCourseRef"
                  :data-text-field="'cdNm'"
                  :data-value-field="'cdId'"
                  v-model="pouchInfo.receiveCourse"
                  :option-label="'수신 코스 선택'"
                  @change="onChangeCourse('receive')"
              >
              </kendo-dropdownlist>
            </li>
          </ul>
        </dd>
        <dd>
          <label class="w30">이메일<span v-show="isDs" class="forg">*</span></label>
          <ul class="w70">
            <li>
              <kendo-maskedtextbox
                  class="w100"
                  :disabled="!isDs"
                  :placeholder="'이메일을 입력하세요.'"
                  v-model.trim="pouchInfo.receiMailAddr"
              >
              </kendo-maskedtextbox>
            </li>
          </ul>
        </dd>
      </li>
      <li>
        <dd>
          <label class="w30">건물</label>
          <ul class="w70">
            <li>
              <kendo-dropdownlist
                  class="w100"
                  ref="receiveBuildingRef"
                  :data-text-field="'cdNm'"
                  :data-value-field="'cdId'"
                  v-model="pouchInfo.receiveBuilding"
                  :option-label="'건물 선택'"
                  @change="onChangeBuilding('receive')"
              >
              </kendo-dropdownlist>
            </li>
          </ul>
        </dd>
        <dd>
          <label class="w30">시간</label>
          <ul class="w70">
            <li>
              <div v-for="item in ampmScnList">
                <input
                    class="k-radio"
                    type="radio"
                    name="receiveAmpmScn"
                    :id="`R${item.cdId}_1`"
                    :value="item.cdId"
                    @change="pouchInfo.receiveAmpmScn = item.cdId"
                    :checked="item.cdId === pouchInfo.receiveAmpmScn">
                <label :for="`R${item.cdId}_1`" class="k-radio-label" style="width:100px">{{ item.cdNm }}</label>
              </div>
            </li>
          </ul>
        </dd>
      </li>
      <li>
        <dd>
          <label class="w30">층</label>
          <ul class="w70">
            <li>
              <kendo-dropdownlist
                  class="w100"
                  ref="receiveFloorRef"
                  :data-text-field="'cdNm'"
                  :data-value-field="'cdId'"
                  v-model="pouchInfo.receiveFloor"
                  :option-label="'층 선택'"
              >
              </kendo-dropdownlist>
            </li>
          </ul>
        </dd>
        <dd>
          <label class="w30">비고</label>
          <ul class="w70">
            <li>
              <kendo-maskedtextbox
                  class="w100"
                  :disabled="!isDs"
                  :placeholder="'비고를 입력하세요.'"
                  v-model.trim="pouchInfo.receiveContents"
              >
              </kendo-maskedtextbox>
            </li>
          </ul>
        </dd>
      </li>
      <li>
        <dd>
          <label class="w30">구역</label>
          <ul class="w70">
            <li>
              <kendo-maskedtextbox
                  class="w100"
                  :placeholder="'구역을 입력하세요.'"
                  v-model.trim="pouchInfo.receiveZone"
              >
              </kendo-maskedtextbox>
            </li>
          </ul>
        </dd>
      </li>
    </ul>
  </div>
</template>

<script>
import {LogisticsCodeDtlMixin, ZoneMixin} from "@/mixin/Mixin";
import EtnersLogisticsUtil from "@/common/etners.logistics.util";
import EtnersCommonUtil from "@/common/etners.common.util";

export default {
  name: "ReceiveInfo",
  mixins: [LogisticsCodeDtlMixin, ZoneMixin],
  props: {
    propsPouchInfo : {
      type : Object,
      required : true,
      default : function (){
        return {}
      }
    },
  },
  watch: {
    'propsPouchInfo': {
      handler: function (val, oldVal) {
        this.pouchInfo = this.propsPouchInfo
        this.setZoneInfo()
      },
      deep: true,
    },
  },
  methods: {
    setZoneInfo () {
      const vm = this
      vm.$refs.receiveFacilityRef.kendoWidget().value(vm.pouchInfo.receiveFacility)
      vm.onChangeFacility('receive')
      vm.$refs.receiveAreaRef.kendoWidget().value(vm.pouchInfo.receiveArea)
      vm.onChangeArea('receive')
      vm.$refs.receiveCourseRef.kendoWidget().value(vm.pouchInfo.receiveCourse)
      vm.onChangeCourse('receive')
      vm.$refs.receiveBuildingRef.kendoWidget().value(vm.pouchInfo.receiveBuilding)
      vm.onChangeBuilding('receive')
    },

    onChangeFacility (gbn) {
      const vm = this
      vm.onChange1Depth(`${gbn}FacilityRef`)
      vm.$refs[`${gbn}AreaRef`].kendoWidget().setDataSource(vm.zone2DepthList)
      vm.$refs[`${gbn}AreaRef`].kendoWidget().value(vm.pouchInfo[`${gbn}Area`])

      // 수신 사업장에 따라 필수값 변동
      const facility = vm.$refs.receiveFacilityRef.kendoWidget().value()
      vm.isDs =  (facility === '01' || facility === '02' || facility === '03' || facility === '04' || facility === '05' || facility === '06' || facility === '07')
    },

    onChangeArea (gbn) {
      const vm = this
      vm.onChange2Depth(`${gbn}AreaRef`)
      vm.$refs[`${gbn}CourseRef`].kendoWidget().setDataSource(vm.zone3DepthList)
      vm.$refs[`${gbn}CourseRef`].kendoWidget().value(vm.pouchInfo[`${gbn}Course`])
    },

    onChangeCourse (gbn) {
      const vm = this
      vm.onChange3Depth(`${gbn}CourseRef`)
      vm.$refs[`${gbn}BuildingRef`].kendoWidget().setDataSource(vm.zone4DepthList)
      vm.$refs[`${gbn}BuildingRef`].kendoWidget().value(vm.pouchInfo[`${gbn}Building`])
    },

    onChangeBuilding (gbn) {
      const vm = this
      vm.onChange4Depth(`${gbn}BuildingRef`)
      vm.$refs[`${gbn}FloorRef`].kendoWidget().setDataSource(vm.zone5DepthList)
      vm.$refs[`${gbn}FloorRef`].kendoWidget().value(vm.pouchInfo[`${gbn}Floor`])
    },

    getReceiveInfo () {
      const vm = this
      if (EtnersCommonUtil.isEmpty(vm.pouchInfo.receiveFacility)) {
        kendo.alert('수신 사업장을 선택해주세요.')
        return false
      }
      if (EtnersCommonUtil.isEmpty(vm.pouchInfo.receiveNm)) {
        kendo.alert('수신을 입력해주세요.')
        return false
      }
      if (EtnersCommonUtil.isEmpty(vm.pouchInfo.receiveDept)) {
        kendo.alert('수신 부서를 입력해주세요.')
        return false
      }
      if (vm.isDs && EtnersCommonUtil.isEmpty(vm.pouchInfo.receiMailAddr)) {
        kendo.alert('이메일을 입력해주세요.')
        return false
      } else if (EtnersCommonUtil.isNotEmpty(vm.pouchInfo.receiMailAddr)) {
        if (!EtnersLogisticsUtil.isEmailDomainAllowed(vm.pouchInfo.receiMailAddr)) {
          kendo.alert(EtnersLogisticsUtil.getEmailDomainAllowedMsg("수신"))
          return false
        }
      }

      return {
        receiveFacility: vm.pouchInfo.receiveFacility,
        receiveArea: vm.pouchInfo.receiveArea,
        receiveCourse: vm.pouchInfo.receiveCourse,
        receiveBuilding: vm.pouchInfo.receiveBuilding,
        receiveFloor: vm.pouchInfo.receiveFloor,
        receiveZone: vm.pouchInfo.receiveZone,
        receiveNm: vm.pouchInfo.receiveNm,
        receiveDept: vm.pouchInfo.receiveDept,
        receiMailAddr: vm.pouchInfo.receiMailAddr,
        receiveAmpmScn: vm.pouchInfo.receiveAmpmScn,
        receiveContents: vm.pouchInfo.receiveContents,
      }
    },
  },
  data () {
    return {
      pouchInfo: {},
      isDs: false,
    }
  }
}
</script>

<style scoped>

</style>